const Caret = ({ direction }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={direction}>
            {/*<path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s1"/>*/}
            {/*<path d="M 20 60 L 50 30 L 80 60" stroke="black" fill="black" strokeWidth="6"/>*/}
            {/*<path d="M4 12l4-4 4 4" />*/}
            <path d="M4 8l4 4 4-4" />
        </svg>
    );
};

export default Caret;